<template>
  <v-form>
    <v-layout row wrap>
      <v-flex xs12 md6>
        <v-layout row>
          <v-flex xs4>
            <v-subheader>Record type</v-subheader>
          </v-flex>
          <v-flex xs8>
            <v-select v-model="filter.recordType" :items="recordTypes"/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4>
            <v-subheader>Record ID</v-subheader>
          </v-flex>
          <v-flex xs8>
            <v-text-field v-model="filter.recordIds"/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4>
            <v-subheader>Affected fields</v-subheader>
          </v-flex>
          <v-flex xs8>
            <v-text-field v-model="filter.affectedFields"/>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md6>
        <v-layout row>
          <v-flex xs4>
            <v-subheader>User</v-subheader>
          </v-flex>
          <v-flex xs8>
            <single-select-search v-model="userId" :options="users" keypath="value"
                                  labelpath="label" minchars="2"/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4>
            <v-subheader>Not before</v-subheader>
          </v-flex>
          <v-flex xs8>
            <date-pick v-model="filter.startDate"/>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4>
            <v-subheader>Not after</v-subheader>
          </v-flex>
          <v-flex xs8>
            <date-pick v-model="filter.endDate"/>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-btn @click="clearFilter">Clear</v-btn>
    <v-btn color="primary" @click="updateFilter">Update</v-btn>
  </v-form>
</template>

<script>
  import { mapActions } from 'vuex';
  import SingleSelectSearch from '../shared/SingleSelectSearch';
  import DatePick from '../shared/DatePick';

  export default {
    components: { SingleSelectSearch, DatePick },
    props: ['recordTypes'],
    data() {
      const filter = this.$store.state.audit.filter;

      return {
        filter: Object.assign({}, filter),
        userId: filter.userIds
      };
    },
    computed: {
      users() {
        return this.$store.state.users.users.map((user) => {
          return {
            label: user.name,
            value: user.aoid
          };
        });
      }
    },
    watch: {
      userId(val) {
        this.filter.userIds = val;
      }
    },
    methods: {
      clearFilter() {
        Object.keys(this.filter).forEach((field) => this.filter[field] = null);
        this.updateFilter();
      },
      updateFilter() {
        this.$store.dispatch('audit/setFilter', this.filter);
        this.$emit('input');
      },
      ...mapActions('users', {
        initializeUsers: 'initialize'
      })
    },
    mounted() {
      this.initializeUsers().catch(this.$defaultHandlerHttp);
    }
  };
</script>

<style scoped>

</style>
